// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CommentList_container__SYpyc {
  height: 45rem;
  flex-wrap: wrap;
  /* width: 45rem; */
}

.CommentList_row__RgC4i {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5px 0;
  box-shadow: none;
  background-color: #47c2bc31;
  height: 4rem;
}

.CommentList_subContainer__eVXK- {
  display: flex;
  justify-content: left;
  align-items: center;
}

.CommentList_image__ngdGq {
  margin: 0.4rem;
  height: 3rem;
  width: 3rem;
  border-radius: 0.5rem;
}

.CommentList_textContainer__FZl4- {
  padding-left: 10;
  width: 50rem;
}

.CommentList_text1__9o7Wz {
  font-weight: 600;
  font-size: 18px;
}

.CommentList_text2__eZDLs {
  padding-top: 10px;
  font-weight: 300;
  font-size: 14px;
}

.CommentList_card__RPS9G {
  margin: 10 10px;
  width: calc(100% - 20px);
  border: 1px solid #ccc;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 50px;
  display: flex;
  flex-direction: column;
}

.CommentList_buttonContainer__o33ZN {
  padding-top: 40px;
  margin-top: auto;
  display: flex;
  justify-content: space-between;
}

.CommentList_verifyButtonContainer__jM9mK {
  display: flex;
}

.CommentList_verifyButton__GWy8N {
  margin-right: 3px;
}

.CommentList_rightButtonContainer__Sej9O {
  display: flex;
}

.CommentList_completeButton__5wBY3 {
  margin-left: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Comments/CommentList.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".container {\r\n  height: 45rem;\r\n  flex-wrap: wrap;\r\n  /* width: 45rem; */\r\n}\r\n\r\n.row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin: 5px 0;\r\n  box-shadow: none;\r\n  background-color: #47c2bc31;\r\n  height: 4rem;\r\n}\r\n\r\n.subContainer {\r\n  display: flex;\r\n  justify-content: left;\r\n  align-items: center;\r\n}\r\n\r\n.image {\r\n  margin: 0.4rem;\r\n  height: 3rem;\r\n  width: 3rem;\r\n  border-radius: 0.5rem;\r\n}\r\n\r\n.textContainer {\r\n  padding-left: 10;\r\n  width: 50rem;\r\n}\r\n\r\n.text1 {\r\n  font-weight: 600;\r\n  font-size: 18px;\r\n}\r\n\r\n.text2 {\r\n  padding-top: 10px;\r\n  font-weight: 300;\r\n  font-size: 14px;\r\n}\r\n\r\n.card {\r\n  margin: 10 10px;\r\n  width: calc(100% - 20px);\r\n  border: 1px solid #ccc;\r\n  border-radius: 0.5rem;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  margin-top: 50px;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.buttonContainer {\r\n  padding-top: 40px;\r\n  margin-top: auto;\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.verifyButtonContainer {\r\n  display: flex;\r\n}\r\n\r\n.verifyButton {\r\n  margin-right: 3px;\r\n}\r\n\r\n.rightButtonContainer {\r\n  display: flex;\r\n}\r\n\r\n.completeButton {\r\n  margin-left: 3px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CommentList_container__SYpyc`,
	"row": `CommentList_row__RgC4i`,
	"subContainer": `CommentList_subContainer__eVXK-`,
	"image": `CommentList_image__ngdGq`,
	"textContainer": `CommentList_textContainer__FZl4-`,
	"text1": `CommentList_text1__9o7Wz`,
	"text2": `CommentList_text2__eZDLs`,
	"card": `CommentList_card__RPS9G`,
	"buttonContainer": `CommentList_buttonContainer__o33ZN`,
	"verifyButtonContainer": `CommentList_verifyButtonContainer__jM9mK`,
	"verifyButton": `CommentList_verifyButton__GWy8N`,
	"rightButtonContainer": `CommentList_rightButtonContainer__Sej9O`,
	"completeButton": `CommentList_completeButton__5wBY3`
};
export default ___CSS_LOADER_EXPORT___;
